import BaseNodeModel from "../BaseNodeModel";

export default class DialogManagerNodeModel extends BaseNodeModel {
    /**
     * Input node model
     * @module DialogManagerNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Dialog Manager";
        this.props.colorClass = "yellow";
        this.props.iconClass = "fast-forward";
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.applyProps(props);
    }

    setConfig(key, value) {
        
        super.setConfig(key, value);
        
    }

    

    getConfigViews() {
        return this.getConfigViewNameField();
    }
}
